<template>
  <licenses-page
    v-if="display"
    :title="title"
    :filter-meta="filterMeta"
    :customer-id="customerId"
  />
</template>

<script>

import { mapActions } from 'vuex'
import LicensesPage from '@/components/pages/Admin/License/LicensesPage'

export default {
  components: {
    LicensesPage
  },

  props: {
    customer: {
      type: Object,
      required: false
    },

    customerId: {
      type: Number,
      required: false
    }
  },

  computed: {
    title () {
      return `${this.customerData.name} - licenser`
    }
  },

  data () {
    return {
      display: false,
      customerData: null, // Don't mutate prop
      filterMeta:
      [
        {
          fieldId: 'product',
          type: 'select',
          label: 'Produkt',
          options: [{
            key: 'InteractiveBowling',
            value: 'Interactive Bowling'
          }, {
            key: 'InteractivePanel',
            value: 'Interactive Panel'
          }]
        },
        {
          fieldId: 'licenseKey',
          type: 'string',
          label: 'Licensnyckel'
        },
        {
          fieldId: 'cpuId',
          type: 'string',
          label: 'CPU-ID'
        },
        {
          fieldId: 'valid',
          type: 'select',
          label: 'Licens giltig',
          options: [{
            key: 'Ok',
            value: 'Giltiga'
          }, {
            key: 'Warning',
            value: 'Varning'
          }, {
            key: 'Error',
            value: 'Ej giltiga'
          }]
        }
      ]
    }
  },

  methods: {
    ...mapActions('customers', ['getById'])
  },

  created () {
    if (!this.customerId && !this.customer) {
      console.error('You need to set either customerId or customer prop')
    }

    const promises = []

    if (!this.customer) {
      promises.push(this.getById(this.customerId).then(data => {
        this.customerData = data.result
      }))
    }
    else {
      this.customerData = this.customer
    }

    Promise.all(promises).then(() => {
      this.display = true
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/Admin/License/CustomerLicensesPage.vue